// extracted by mini-css-extract-plugin
module.exports = {"pill":"highlight-wrapper_pill__aGsbE","header":"highlight-wrapper_header__rqZRG"};